import React, { createContext, useCallback, useContext, useRef } from 'react'

const InterviewLeaveGuardContext = createContext(null)

export function InterviewLeaveGuardProvider({ children }) {
  const guardRef = useRef(null)

  const registerGuard = useCallback((guard) => {
    guardRef.current = guard
  }, [])

  const unregisterGuard = useCallback(() => {
    guardRef.current = null
  }, [])

  const attemptNavigation = useCallback((navigateFn) => {
    const guard = guardRef.current
    if (guard?.shouldBlock?.()) {
      guard.onBlock(navigateFn)
      return false
    }
    if (typeof navigateFn === 'function') {
      navigateFn()
    }
    return true
  }, [])

  return (
    <InterviewLeaveGuardContext.Provider value={{ registerGuard, unregisterGuard, attemptNavigation }}>
      {children}
    </InterviewLeaveGuardContext.Provider>
  )
}

export function useInterviewLeaveGuard() {
  return useContext(InterviewLeaveGuardContext)
}
